<template>
  <div>
    <CRow>
      <CCol><h3>Add user</h3></CCol>
      <CCol>
        <router-link to="/users">
          <CButton color="primary" class="float-right">
            Back to user list
          </CButton></router-link
        >
      </CCol>
    </CRow>
    <CCard>
      <CCardBody>
        <CCardTitle>User Details</CCardTitle>
        <CRow>
          <CCol sm="8">
            <CInput
              label="Name"
              v-model="user.name"
              placeholder="Enter your name"
              :isValid="isNameValid()"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="8">
            <CInput
              label="Email Address"
              v-model="user.email"
              placeholder="Enter your email address"
              :isValid="isEmailValid()"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="8">
            <CSelect
              label="Select Organization"
              :value.sync="user.app_metadata.organization"
              :options="orgNames"
              placeholder="Please select Organization"
            />
          </CCol>
        </CRow>
        <CRow class="mb-2" alignVertical="center">
          <CCol sm="8">
            <CInput
              label="Password"
              type="text"
              class="mb-0"
              v-model="user.password"
              placeholder="Enter Password"
              :isValid="isPasswordValid(user.password)"
            >
            </CInput>
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="8">
            <CInput
              label="Confirm Password"
              type="text"
              v-model="confirmPassword"
              placeholder="Confirm Password"
              :isValid="isConfirmPassValid(confirmPassword)"
            />
          </CCol>
        </CRow>
        <h5 class="mt-3">Account Type</h5>
        <CRow align="center">
          <CCol sm="3" class="my-3">
            <CInputCheckbox
              label="Trial User"
              :checked.sync="user.app_metadata.trial_user"
            ></CInputCheckbox>
          </CCol>

          <CCol sm="5" v-if="user.app_metadata.trial_user">
            <datetime type="date" v-model="user.app_metadata.trial_expiry">
              <label for="startDate" slot="before">Trial Expiry: </label>
              <span class="description" slot="after"
                ><br /><small><i>Expiry for trial account</i></small></span
              >
            </datetime>
          </CCol>
        </CRow>

        <CRow
          v-for="number in numberOfRoles"
          :key="number"
          alignVertical="center"
        >
          <CCol sm="8" class="mt-3">
            <h5>Roles</h5>
            <CSelect :options="roles" :value.sync="role[number - 1]"></CSelect>
          </CCol>
          <CCol sm="4" v-if="numberOfRoles > 1">
            <a @click="reduceNumberOfRole(number)" v-if="number !== 1">
              <CIcon name="cilXCircle" class="pointer" />
            </a>
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="8">
            <a class="pointer" @click="addNumberOfRole"
              ><u>Click to add another role.</u></a
            >
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="8" v-if="!loading" class="my-3">
            <CButton
              color="info"
              variant="outline"
              square
              :disabled="loading == true"
              @click="showModal = true"
            >
              Add new user
            </CButton>
          </CCol>
          <CCol sm="8" v-else class="my-3">
            <CSpinner color="success" />
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CToaster :autohide="3000" v-if="error.showError">
      <template>
        <CToast :show="true" header="Toast">
          {{ error.text }}
        </CToast>
      </template>
    </CToaster>
    <TheModal
      :color="'warning'"
      :size="'sm'"
      :title="'Add new user'"
      :showModal="showModal"
      :text="`Are you sure you want to add user <b>${user.email}</b>.`"
      @cancel="cancelAddUser($event)"
      @okay="addUser($event)"
    />
    <pre>{{ trial_expiry_text }}</pre>
    <pre>{{ user }}</pre>
    <pre>{{ role }}</pre>
  </div>
</template>

<script>
import getNested from "lodash-es/get";
import { mapActions, mapState } from "vuex";
import moment from "moment";
import TheModal from "./../containers/TheModal";
import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
export default {
  name: "AddUser",
  data() {
    return {
      orgs: [],
      confirmPassword: "",
      role: [null],
      trial_expiry_text: "",
      user: {
        name: "",
        email: "",
        app_metadata: {
          organization: "",
          trial_user: false,
          trial_expiry: moment()
            .add(14, "days")
            .toISOString(),
        },
        password: "",
        email_verified: true,
        connection: "Username-Password-Authentication",
      },
      showPassword: false,
      error: {
        showError: false,
        text: "",
      },
      numberOfRoles: 1,
      loading: false,
      showModal: false,
    };
  },
  components: {
    TheModal,
    Datetime,
  },
  async mounted() {
    await this.getRoles();
    await this.loadOrgs();
  },
  computed: {
    ...mapState(["roles"]),
    orgNames() {
      return this.orgs.map((item) => item.organizationId);
    },
  },

  methods: {
    ...mapActions("users", ["listOrgs"]),

    ...mapActions(["getRoles", "createUser", "addRoleToUser"]),

    async loadOrgs() {
      let data = await this.listOrgs();
      this.orgs = getNested(data, "organizations", []);
    },

    async addUser() {
      this.showModal = false;
      if (
        this.isNameValid() &&
        this.isEmailValid() &&
        this.user.app_metadata.organization &&
        this.isPasswordValid(this.user.password) &&
        this.isConfirmPassValid(this.confirmPassword)
      ) {
        this.loading = true;
        let response = await this.createUser(this.user);
        if (response.error) {
          this.error.showError = true;
          this.error.text = response.error_details.message;
          setTimeout(
            function(that) {
              that.error.showError = false;
              that.error.text = "";
            },
            3000,
            this
          );
        } else {
          if (this.role.length && this.role[0] !== null) {
            this.role.forEach(async (role) => {
              let roleresponse = await this.addRoleToUser({
                id: response.data.user_id,
                roleId: role,
              });
              if (!roleresponse) {
                this.error.showError = true;
                this.error.text = "Can not assign role";
              }
            });
          }
          this.user = {
            name: "",
            email: "",
            app_metadata: {
              organization: "",
              trial_user: false,
              trial_expiry: moment()
                .add(14, "days")
                .toISOString(),
            },
            password: "",
            email_verified: true,
            connection: "Username-Password-Authentication",
          };
          this.confirmPassword = "";
          this.error.showError = true;
          this.error.text = "User Created";
          this.$router.push("/users");
        }
        this.loading = false;
      } else {
        this.error.showError = true;
        this.error.text = "Please correctly fill all fields";
        setTimeout(
          function(that) {
            that.error.showError = false;
            that.error.text = "";
          },
          3000,
          this
        );
      }
    },
    isNameValid() {
      return true;
    },
    isEmailValid() {
      if (this.user.email.length) {
        if (
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.user.email)
        )
          return true;
        return false;
      }
    },
    isPasswordValid(password) {
      if (password.length) {
        if (password.length >= 7) return true;
        return false;
      }
    },
    isConfirmPassValid(password) {
      if (password.length) {
        if (password === this.user.password) return true;
        return false;
      }
    },
    passwordShowFunction() {
      this.showPassword = !this.showPassword;
    },
    callFunction() {
      console.log("calling");
    },
    addNumberOfRole() {
      if (this.numberOfRoles < this.roles.length - 1) {
        this.numberOfRoles++;
        this.role.push(null);
      }
    },
    reduceNumberOfRole(index) {
      if (this.numberOfRoles > 1) {
        this.role.splice(index - 1, 1);
        this.numberOfRoles = this.numberOfRoles - 1;
      }
    },
    cancelAddUser() {
      this.showModal = false;
    },
  },
};
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>
